import styleParam from '../BookingCalendar/stylesParams';

export default styleParam;
